<mat-card *ngIf="dataSource.length">
    <mat-table #table [dataSource]="dataSource">
        <!-- Type Column -->
        <ng-container cdkColumnDef="icon">
            <mat-header-cell *cdkHeaderCellDef fxFlex="64px"></mat-header-cell>
            <mat-cell *cdkCellDef="let row" fxFlex="64px">
                <mat-icon *ngIf="row?.Type === 'DriveFolder' || row?.Type === 'SharedFolder'" [style.color]="row?.Color"
                    class="type-icon dms-folder-icon">
                    folder
                </mat-icon>
                <mat-icon *ngIf="row?.Type === 'DriveFile' || row?.Type === 'SharedFile'" class="type-icon">
                    {{row?.IconName}}</mat-icon>
            </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container cdkColumnDef="name">
            <mat-header-cell class="font-weight-600 font-size-14" *cdkHeaderCellDef>
                {{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_NAME" | translate }}
            </mat-header-cell>
            <mat-cell *cdkCellDef="let row">
                <span *ngIf="!State.IsParentSecure">
                    {{(row?.Name.length>24)? (row?.Name | slice:0:24)+'..':(row?.Name)}}</span>
                <b *ngIf="State.IsParentSecure">
                    {{(row?.Name.length>24)? (row?.Name | slice:0:24)+'..':(row?.Name)}}</b>
            </mat-cell>
        </ng-container>

        <!-- Type Column -->
        <ng-container cdkColumnDef="type">
            <mat-header-cell fxFlex="80px" class="font-weight-600 font-size-14" *cdkHeaderCellDef fxHide fxShow.gt-md>
                {{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_TYPE" | translate }}
            </mat-header-cell>
            <mat-cell fxFlex="80px" *cdkCellDef="let row" fxHide fxShow.gt-md>
                {{ (row?.Type === "DriveFolder" || row?.Type === "SharedFolder" ?
                "APP_PLATFORM_DOCUMENT_MANAGER.DMS_FOLDER" : "APP_PLATFORM_DOCUMENT_MANAGER.DMS_FILE" ) | translate }}
            </mat-cell>
        </ng-container>

        <!-- Size Column -->
        <ng-container cdkColumnDef="size">
            <mat-header-cell class="font-weight-600 font-size-14" fxFlex="80px" *cdkHeaderCellDef fxHide.xs>
                {{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_SIZE" | translate }}
            </mat-header-cell>
            <mat-cell fxFlex="80px" *cdkCellDef="let row" fxHide.xs>
                {{ row?.Type === "DriveFolder" || row?.Type === "SharedFolder" ? "-" : (row.FileSizeInKB*1024 || 0 |
                fileSize: "1.0-2") }}
            </mat-cell>
        </ng-container>

        <!-- Modified Column -->
        <ng-container cdkColumnDef="created">
            <mat-header-cell fxFlex="100px" class="font-weight-600 font-size-14" *cdkHeaderCellDef fxHide fxShow.gt-md>
                {{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_CREATED_AT" | translate }}
            </mat-header-cell>
            <mat-cell fxFlex="100px" *cdkCellDef="let row" fxHide fxShow.gt-md>
                {{ row?.CreateDate | date: "mediumDate" }}
            </mat-cell>
        </ng-container>

        <!-- createdBy Column -->
        <ng-container cdkColumnDef="createdBy">
            <mat-header-cell class="font-weight-600 font-size-14" *cdkHeaderCellDef fxHide fxShow.gt-md>
                {{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_CREATED_BY" | translate }}
            </mat-header-cell>
            <mat-cell *cdkCellDef="let row" fxHide fxShow.gt-md>{{ row?.OwnerName ? row?.OwnerName : "-" }}</mat-cell>
        </ng-container>

        <!-- shareBy Column -->
        <!-- <ng-container cdkColumnDef="shareBy">
            <mat-header-cell class="font-weight-600 font-size-14" *cdkHeaderCellDef fxHide fxShow.gt-md>
                {{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SHARED_BY'|translate}}
            </mat-header-cell>
            <mat-cell *cdkCellDef="let row" fxHide fxShow.gt-md>{{ row?.SharedByUserName?row?.SharedByUserName:'-'}}</mat-cell>
        </ng-container> -->

        <!-- Action Column -->
        <ng-container cdkColumnDef="action">
            <mat-header-cell *cdkHeaderCellDef fxFlex="100px"></mat-header-cell>
            <mat-cell *cdkCellDef="let row" fxFlex="100px">
                <!-- <button mat-icon-button type="button" class="" (click)="addOrRemoveFavourite(row)" *ngIf="
                (dmsConfig && dmsConfig.isPowerUser) || row.Type === 'DriveFolder' || row.Type === 'DriveFile'
            ">
                    <mat-icon>{{!row.IsFavorite?"favorite_border":"favorite"}}</mat-icon>

                </button> -->
                <button mat-icon-button [matMenuTriggerFor]="measdasdnu" class="folder-context-menu-icon" *ngIf="
                        row.Type === 'DriveFolder' || row.Type === 'DriveFile'
                    ">
                    <mat-icon>more_vert</mat-icon>
                </button>

                <button mat-icon-button [matMenuTriggerFor]="menu2" class="folder-context-menu-icon"
                    *ngIf="row.Type === 'SharedFile'">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #measdasdnu="matMenu">
                    <button *ngIf="
                            (row?.Type === 'DriveFile' || row?.Type === 'SharedFile') &&
                            (!State.IsParentSecure || State.DownloadSecureFile)
                        " mat-menu-item (click)="download(row)">
                        <mat-icon class="material-icons mr-12">cloud_download</mat-icon>
                        {{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_DOWNLOAD" | translate }}
                    </button>

                    <button *ngIf="row?.Type === 'DriveFolder'" mat-menu-item [matMenuTriggerFor]="colorPick">
                        <mat-icon class="material-icons">color_lens</mat-icon>
                        <span>{{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_CHANGE_COLOR" | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="remove(row)" *ngIf="
                            UserId === row.sharedToUserId ||
                            UserId === row.OwnerId ||
                            row.Type === 'DriveFolder' ||
                            row.Type === 'DriveFile'
                        ">
                        <mat-icon class="material-icons mr-12">delete</mat-icon>
                        <span>{{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_REMOVE" | translate }}</span>
                    </button>
                </mat-menu>

                <mat-menu #menu2>
                    <button mat-menu-item (click)="download(row)">
                        <mat-icon class="material-icons mr-12">cloud_download</mat-icon>
                        {{ "APP_PLATFORM_DOCUMENT_MANAGER.DMS_DOWNLOAD" | translate }}
                    </button>
                </mat-menu>

                <mat-menu #colorPick="matMenu" class="pl-8">
                    <div fxLayout="row wrap" fxLayoutGap="8px" style="max-width: 192px">
                        <div *ngFor="let color of colors; let i = index">
                            <div (click)="changeColor(color, row, i)" class="color-box" style="margin-top: 8px"
                                [ngStyle]="{ 'background-color': color }"></div>
                        </div>
                    </div>
                </mat-menu>
            </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *cdkRowDef="let row; columns: displayedColumns; let i = index"
            (click)="onSelect(row); clickStream.next(row);" [ngClass]="{ 'selection-color': row === selected }"
            (clickOutside)="
            State.SelectedItemIds.includes(row.ItemId)
            ? Actions.OnClickOutside(row.ItemId, $event)
            : Actions.DoNothing()
            " click-outside matRipple>
            <!-- <context-menu #basicMenu>
                <ng-template contextMenuItem>
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon class="material-icons mr-12">share</mat-icon>
                        <span>{{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SHARE'|translate}}</span>
                    </div>
                </ng-template>
                <ng-template *ngIf="row?.Type === 'DriveFolder'" contextMenuItem let-Folder (execute)="rename(row)">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon class="material-icons mr-12">edit</mat-icon>
                        <span>{{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_RENAME'|translate}}</span>
                    </div>
                </ng-template>
                <ng-template *ngIf="row?.Type === 'DriveFile'" contextMenuItem let-row (execute)="download(row)">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon class="material-icons mr-12">cloud_download</mat-icon>
                        {{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_DOWNLOAD'|translate}}
                    </div>
                </ng-template>
                <ng-template *ngIf="row?.Type === 'DriveFolder'" contextMenuItem [subMenu]="saySubMenu">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon class="material-icons mr-12">color_lens</mat-icon>
                        <span>{{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_CHANGE_COLOR'|translate}}</span>
                    </div>
                </ng-template>
                <context-menu #saySubMenu [menuClass]="'no-hover'">
                    <ng-template contextMenuItem let-Folder>
                        <div fxLayout="row wrap" fxLayoutGap="8px" style="max-width: 192px;">
                            <div *ngFor="let color of colors;">
                                <div (click)="changeColor(color, Folder, i)" class="color-box" style="margin-top: 8px;"
                                    [ngStyle]="{'background-color': color}"></div>
                            </div>
                        </div>
                    </ng-template>
                </context-menu>
                <ng-template contextMenuItem let-row (execute)="remove(row)">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon class="material-icons mr-12">delete</mat-icon>
                        <span>{{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_REMOVE'|translate}}</span>
                    </div>
                </ng-template>
            </context-menu> -->
        </mat-row>
    </mat-table>
</mat-card>